import Decimal from 'decimal.js'
import { atom } from 'recoil'
import { selectorWithoutCache as selector } from 'util/RecoilWithoutCache'

interface IspotAccountItem {
    available: string // 用户自己的余额 + 跟单占用
    coinId: string // 币 id
    coinName: string // 币名
    costPrice: string // 成本价
    reserved: string // 占用 reserved =  frozen + lock + limitAvailable
    total: string // 总额 total = available + frozen + lock
    frozen: string // 冻结
    lock: string // 锁定
    limitAvailable: string // 跟单占用
}
interface IMixSpotAccountState {
    [key: string]: IspotAccountItem
}
/**
 * ws 订阅 account 存放 数据的 atom
 */
export const MixSpotAccountState = atom<IMixSpotAccountState | {}>({
    key: 'mix-spot-account-state-x',
    default: {}
})
/**
 * ws 订阅 account 设置 获取 数据的 selector
 */
export const MixSpotAccountSelector = selector({
    key: 'mix-spot-Account-selector-x',
    get: ({ get }) => {
        const walletsMap = get(MixSpotAccountState)
        return walletsMap
    },
    set: ({ get, set }, data: any[]) => {
        let walletsMap = get(MixSpotAccountState)

        // 没推数据 不更新
        if (!data.length) {
            return
        }
        // 推送有数据
        else {
            let objTmp = { ...walletsMap }
            data.forEach(item => {
                // 成本价 如果ws   没有数据 || '0' => 0.00 ，ws 有数据 直接取
                let costPrice = '0.00'
                if (item?.costPrice && item?.costPrice !== '0') {
                    costPrice = item.costPrice
                }

                // 占用 reserved =  frozen + lock + limitAvailable
                let reserved = new Decimal(item?.frozen || '0')
                    .add(item?.lock || '0')
                    .add(item?.limitAvailable || '0')
                    .toFixed(8, Decimal.ROUND_DOWN)

                // 总额 total = available + frozen + lock
                let total = new Decimal(item?.available || '0')
                    .add(item?.frozen || '0')
                    .add(item?.lock || '0')
                    .toFixed(8, Decimal.ROUND_DOWN)

                objTmp[item.coinName.toUpperCase()] = {
                    ...item,
                    costPrice,
                    reserved,
                    total
                }
            })
            set(MixSpotAccountState, objTmp)
        }
    }
})
